import { IXmlNode } from '@/app-modules/server-communications';
import { safeCast } from '@/helper';
import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';

export abstract class WinnersData {
    public jackpotWon: boolean;
    public winners: StageWinnerResponse[] = [];

    protected abstract getStages(node: IXmlNode): DefaultStageElement[];
    protected abstract getJackpotStage(): number;

    constructor(node: IXmlNode) {
        this.winners = this.getWinners(node);
    }

    private getWinners(node: IXmlNode): StageWinnerResponse[] {
        const stageList = node.childNodes.stage;
        const winnersList: StageWinnerResponse[] = new Array<StageWinnerResponse>();
        const stageElements = this.getStages(node);

        stageList.forEach((stage) => {
            const stageElement = stageElements.find((obj) => obj.stage.toString() === stage.attributes.stage);
            if (stageElement) {
                const stagePrizeName = stageElement.name;

                winnersList.push(new StageWinnerResponse(stage, stagePrizeName));
                if (stage.attributes.stage === this.getJackpotStage().toString()) {
                    this.jackpotWon = true;
                }
            }
        });

        return winnersList;
    }
}

export class StageWinnerResponse {
    public stage: number;
    public prizeName: string;
    public quantity: number;
    public winners: UserResponse[];

    constructor(messageNode: IXmlNode, prizeName: string) {
        this.stage = safeCast(messageNode.attributes.stage, 0);
        this.prizeName = safeCast(prizeName, '');
        this.quantity = safeCast(messageNode.attributes.quantity, 0);
        this.winners = new Array<UserResponse>();
        const winnersList = messageNode.childNodes.winner || messageNode.childNodes.Winner;

        if (winnersList) {
            winnersList.forEach((winner) => {
                this.winners.push(new UserResponse(winner));
            });
        }
    }
}

export class UserResponse {
    public username: string;
    public prizeInPence: number;

    constructor(messageNode: IXmlNode) {
        this.username = messageNode.attributes.user || messageNode.attributes.User;
        this.prizeInPence = safeCast(messageNode.attributes.prize, 0);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/winners/winners-data.ts